<div
  id="due_for_termination1"
  *ngIf="carDetails?.status === DUE_FOR_TERMINATION && !displayHead"
  class="overlay-banner-top"
>
  DUE FOR TERMINATION
</div>
<div
  id="new_railcar_builds"
  *ngIf="carDetails?.status === NEW_RAILCAR_BUILDS && !displayHead"
  class="overlay-banner-top new-build"
>
  NEW RAILCAR BUILDS
</div>
<div
  id="newbuilds"
  *ngIf="fromNewBuilds && !displayHead"
  class="overlay-banner-top new-build"
>
  NEW RAILCAR BUILD
</div>
<div class="card" *ngIf="!blank; else blankTemplate" id="div_card_eb81db8d">
  <div class="header" *ngIf="displayHead" id="div_header_b5688bc7">
    <img
      class="car-img"
      [src]="_imageURL_"
      alt="Car Image"
      title="Car Image"
      aria-label="Car Image"
      onerror="this.src='../../../assets/images/image-not-found.webp'"
      id="img_car-img_e4491a76"
    />
    <div
      id="due_for_termination"
      *ngIf="carDetails?.status === DUE_FOR_TERMINATION"
      class="overlay-banner"
    >
      DUE FOR TERMINATION
    </div>
    <div
      id="new_railcar_builds1"
      *ngIf="carDetails?.status === NEW_RAILCAR_BUILDS"
      class="overlay-banner new-build"
    >
      NEW RAILCAR BUILDS
    </div>
    <div
      class="select-btn"
      (click)="toggleSelected()"
      id="div_select-btn_518f5717"
    >
      <div
        class="selected-btn"
        *ngIf="selected; else unselected"
        id="div_selected-btn_f99dfcb9"
      >
        <span id="span_8c448160">Selected</span>
        <img
          class="selected-icon"
          src="../../../assets/icons/checkmark-icon.svg"
          alt="Checkmark Icon"
          title="Checkmark Icon"
          aria-label="Checkmark Icon"
          id="img_selected-icon_45de0f4c"
        />
      </div>
      <ng-template #unselected="" id="ng-template_0be6c70c">
        <div
          class="unselected-btn"
          [ngClass]="selectEnabled ? 'select-enabled' : 'select-disabled'"
          id="div_unselected-btn_d9e0bd1e"
        >
          <span *ngIf="showSelect" id="span_96aa6235">Select</span>
        </div>
      </ng-template>
    </div>
  </div>
  <div class="card-body" id="div_card-body_89d7e585">
    <div
      *ngIf="carDetails?.status !== NEW_RAILCAR_BUILDS"
      class="card-title"
      [ngStyle]="{ 'flex-grow': fromNewBuilds ? '0' : '1' }"
      id="div_card-title_a60409b6"
    >
      <span
        class="car-name"
        (click)="openModal()"
        id="span_car-name_4c784487"
        >{{ carDetails.model_desc }}</span
      >
      <img
        class="car-tooltip-icon"
        *ngIf="displayHead"
        (click)="openModal()"
        src="../../../assets/icons/tooltip-icon.svg"
        alt="Tooltip Icon"
        title="Tooltip Icon"
        aria-label="Tooltip Icon"
        id="img_car-tooltip-icon_b54e2904"
      />

      <i
        *ngIf="displayClear"
        (click)="toggleSelected()"
        class="cross-icon"
        id="i_cross-icon_8d8d9e4e"
      ></i>
    </div>

    <div
      *ngIf="fromNewBuilds"
      class="car-attrs-wrapper"
      id="div_car-attrs-zXxzXX"
    >
      <div class="car-specs" id="div_car-specs_0f3feb32qq">
        <span class="new-build-detail" id="span_deasatail_817a9d07">{{
          carDetails.car_overview
        }}</span>
      </div>
    </div>
    <div
      *ngIf="carDetails?.status === NEW_RAILCAR_BUILDS"
      id="div_car-attrs-zXxzXXasda"
    >
      <h4 class="product-title">{{ carDetails?.model_desc }}</h4>
      <p class="product-description" [title]="carDetails.car_overview">
        {{ truncateText(carDetails?.car_overview, 150) }}
      </p>
      <p class="product-pricing">
        {{
          carDetails?.rate
            ? '$' + carDetails?.rate
            : 'Pricing available upon request'
        }}
      </p>
    </div>
    <div
      *ngIf="!fromNewBuilds && carDetails?.status !== NEW_RAILCAR_BUILDS"
      class="car-attrs-wrapper"
      id="div_car-attrs-wrapper_3965d77a"
    >
      <ng-container
        *ngFor="let carDetail of displayedAttr"
        id="ng-container_0c0ba365"
      >
        <div
          class="car-specs"
          *ngIf="checkConditionalDisplayAttr(carDetail)"
          id="div_car-specs_0f3feb32"
        >
          <span class="detail label" id="span_detail_817a9d07"
            >{{ carDetail.title }}
            <i id="i_9bc4de51">{{ carDetail.labelTail }}</i></span
          >
          <span
            class="detail-value"
            *ngIf="isNan(carDetails[carDetail.field]); else number"
            id="span_detail-value_f808388a"
            >{{ carDetails[carDetail.field] }} {{ carDetail.valueTail }}</span
          >
          <ng-template #number="" id="ng-template_0569efdf">
            <span class="detail-value" id="span_detail-value_807ea4a3"
              >{{ carDetails[carDetail.field] | number: '1.0' : 'en-US' }}
              {{ carDetail.valueTail }}</span
            >
          </ng-template>
        </div>
      </ng-container>
    </div>

    <div *ngIf="carDetails?.status === NEW_RAILCAR_BUILDS" class="card-foot">
      <a (click)="openModel(carDetails)" class="product-link">Learn more</a>
    </div>

    <hr
      *ngIf="!fromNewBuilds && carDetails?.status !== NEW_RAILCAR_BUILDS"
      id="hr_8c960510"
    />

    <div
      *ngIf="!fromNewBuilds && carDetails?.status !== NEW_RAILCAR_BUILDS"
      class="card-foot"
      id="div_card-foot_0cc43a0d"
    >
      <div class="car-qty-wrapper" id="div_car-qty-wrapper_1617c138">
        <span class="car-qty" [ngSwitch]="true" id="span_car-qty_e07570e2">
          <ng-container
            *ngSwitchCase="carDetails.count < 5"
            id="ng-container_88d5a0b6"
            >Limited Qty</ng-container
          >
          <ng-container
            *ngSwitchCase="carDetails.count > 25"
            id="ng-container_8d3a5070"
            >25+ Qty</ng-container
          >
          <ng-container *ngSwitchDefault id="ng-container_415893f2"
            >{{ carDetails.count }} Qty</ng-container
          >
        </span>
        <div class="car-location" id="div_car-location_3e696240">
          <img
            class="car-location-icon"
            src="../../../assets/icons/location-icon.svg"
            alt="Location Icon"
            title="Location Icon"
            aria-label="Location Icon"
            id="img_car-location-icon_662b2363"
          />
          <span
            class="car-location-label"
            id="span_car-location-label_501fafff"
            >{{ carDetails.display_location || carDetails.state }}</span
          >
        </div>
      </div>

      <div class="car-cost-wrapper" id="div_car-cost-wrapper_317c1ce4">
        <span
          class="car-cost"
          *ngIf="carDetails.count >= 10"
          id="span_car-cost_6d090d85"
        >
          ${{ carDetails.rate | number: '1.0-2' }}–{{
            carDetails.rate2 | number: '1.0-2'
          }}
        </span>
        <span class="car-cost-label" id="span_car-cost-label_b6be7e7e"
          >Railcar/mo (as-is)</span
        >
      </div>
    </div>
  </div>
</div>
<ng-template #blankTemplate="" id="ng-template_2f59a467">
  <div class="card blank" id="div_card_f8e8090b">
    <div class="header" id="div_header_c5e26fec">
      <div class="select-btn" id="div_select-btn_3de9d1a6">
        <div
          class="unselected-btn select-disabled"
          id="div_unselected-btn_aa19f1ef"
        >
          <span id="span_e024c367">Select</span>
        </div>
      </div>
    </div>
    <div class="card-body" id="div_card-body_ac8de3af">
      <div class="blank-title" id="div_blank-title_019b277f"></div>
      <div class="blank-content" id="div_blank-content_a6a0c058">
        <div class="blank-specs left" id="div_blank-specs_104e1831"></div>
        <div class="blank-specs right" id="div_blank-specs_b4d938fe"></div>
      </div>
      <div class="blank-foot" id="div_blank-foot_7285d89d">
        <div class="left" id="div_left_133dae7a">
          <div id="div_12cf0c29"></div>
          <div id="div_b1367674"></div>
        </div>
        <div class="right" id="div_right_626d5afe">
          <div class="top" id="div_top_e1cb86eb"></div>
          <div class="bottom" id="div_bottom_20b9e61b"></div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<p-dialog
  [(visible)]="isDisplayingDialog"
  [draggable]="false"
  [modal]="true"
  [dismissableMask]="true"
  [showHeader]="false"
  [focusTrap]="false"
  (onHide)="closeModel()"
  position="top"
  maskStyleClass="detail-dialog"
  id="p-dialog_1ca03474"
>
  <ng-container
    *ngIf="isDisplayingDialog && !!detailViewObj"
    id="ng-container_179fbb42"
  >
    <app-new-builds-learn-more
      (closeNewModelFn)="closeModel()"
      (selectedCar)="carSelected($event)"
      [carDetails]="detailViewObj"
      [showBegin]="false"
    ></app-new-builds-learn-more>
  </ng-container>
</p-dialog>
